/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

  document.addEventListener("DOMContentLoaded", function () {

    // ========================================
    // PRODUCT GRID ALWAYS-ON SLIDESHOW
    // Replaces hover-only slideshow with:
    // - Desktop: always visible, nav arrows on hover
    // - Mobile: swipeable, no nav arrows
    // ========================================
    function initProductGridSlideshows() {
      const slideshowHolders = document.querySelectorAll('hover-slideshow .product__media__slider--always, div .product__media__slider--always');
      slideshowHolders.forEach(function(holder) {
        initSingleSlideshow(holder);
      });
    }

    function initSingleSlideshow(holder) {
      const parent = holder.closest('.product__media__container') || holder.closest('.product-grid-item__image');
      if (!parent || holder.dataset.slideshowInit === 'true') return;
      holder.dataset.slideshowInit = 'true';

      const slides = holder.querySelectorAll('[data-hover-slideshow-item]');
      if (slides.length <= 1) return;

      // Destroy any Flickity instance that the theme may have created
      if (window.theme && window.theme.Flickity) {
        try {
          var flktyInstance = window.theme.Flickity.data(holder);
          if (flktyInstance && flktyInstance.isActive) {
            flktyInstance.destroy();
          }
        } catch(e) { /* ignore */ }
      }

      const navContainer = parent.querySelector('[data-slideshow-nav]');
      const dotsContainer = parent.querySelector('[data-slideshow-dots]');
      const prevBtn = parent.querySelector('[data-slideshow-prev]');
      const nextBtn = parent.querySelector('[data-slideshow-next]');
      const dots = dotsContainer ? dotsContainer.querySelectorAll('[data-slideshow-dot]') : [];

      let currentIndex = 0;
      const totalSlides = slides.length;

      // Lazy-load: defer loading of non-first slide images
      // Move src/srcset to data-src/data-srcset for slides beyond the first
      slides.forEach(function(slide, i) {
        if (i === 0) return; // Keep first slide (featured image) loaded
        var imgs = slide.querySelectorAll('img[src], img[srcset]');
        imgs.forEach(function(img) {
          if (img.getAttribute('src')) {
            img.setAttribute('data-lazy-src', img.getAttribute('src'));
            img.removeAttribute('src');
          }
          if (img.getAttribute('srcset')) {
            img.setAttribute('data-lazy-srcset', img.getAttribute('srcset'));
            img.removeAttribute('srcset');
          }
        });
        var sources = slide.querySelectorAll('source[srcset]');
        sources.forEach(function(source) {
          source.setAttribute('data-lazy-srcset', source.getAttribute('srcset'));
          source.removeAttribute('srcset');
        });
      });

      // Load images for a specific slide
      function loadSlideImages(slideIndex) {
        var slide = slides[slideIndex];
        if (!slide || slide.dataset.imagesLoaded === 'true') return;
        slide.dataset.imagesLoaded = 'true';
        var imgs = slide.querySelectorAll('img[data-lazy-src], img[data-lazy-srcset]');
        imgs.forEach(function(img) {
          if (img.getAttribute('data-lazy-srcset')) {
            img.setAttribute('srcset', img.getAttribute('data-lazy-srcset'));
            img.removeAttribute('data-lazy-srcset');
          }
          if (img.getAttribute('data-lazy-src')) {
            img.setAttribute('src', img.getAttribute('data-lazy-src'));
            img.removeAttribute('data-lazy-src');
          }
        });
        var sources = slide.querySelectorAll('source[data-lazy-srcset]');
        sources.forEach(function(source) {
          source.setAttribute('srcset', source.getAttribute('data-lazy-srcset'));
          source.removeAttribute('data-lazy-srcset');
        });
      }

      // Preload adjacent slides
      function preloadAdjacentSlides(index) {
        var next = (index + 1) % totalSlides;
        var prev = (index - 1 + totalSlides) % totalSlides;
        loadSlideImages(next);
        loadSlideImages(prev);
      }

      // Mark first slide as loaded and preload its neighbors
      slides[0].dataset.imagesLoaded = 'true';
      preloadAdjacentSlides(0);

      // Position slides side by side — no transition on init to avoid flash
      slides.forEach(function(slide, i) {
        slide.style.position = 'absolute';
        slide.style.top = '0';
        slide.style.left = '0';
        slide.style.width = '100%';
        slide.style.height = '100%';
        slide.style.transition = 'none';
        slide.style.transform = 'translateX(' + (i * 100) + '%)';
      });

      // Mark as initialized — CSS will now show all slides
      holder.classList.add('is-initialized');

      // Enable transitions after initial positioning is painted
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          slides.forEach(function(slide) {
            slide.style.transition = 'transform 0.35s cubic-bezier(0.25, 0.1, 0.25, 1)';
          });
        });
      });

      function goToSlide(index) {
        if (index < 0) index = totalSlides - 1;
        if (index >= totalSlides) index = 0;
        currentIndex = index;

        // Load current and adjacent slide images
        loadSlideImages(currentIndex);
        preloadAdjacentSlides(currentIndex);

        slides.forEach(function(slide, i) {
          slide.style.transform = 'translateX(' + ((i - currentIndex) * 100) + '%)';
        });

        // Update dots
        dots.forEach(function(dot, i) {
          dot.classList.toggle('is-active', i === currentIndex);
        });
      }

      // Navigation buttons
      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          goToSlide(currentIndex - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          goToSlide(currentIndex + 1);
        });
      }

      // Dots navigation
      dots.forEach(function(dot) {
        dot.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var idx = parseInt(dot.getAttribute('data-slideshow-dot'), 10);
          goToSlide(idx);
        });
      });

      // Touch/Swipe support for mobile
      let touchStartX = 0;
      let touchStartY = 0;
      let touchEndX = 0;
      let isSwiping = false;
      const swipeThreshold = 40;

      holder.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
        isSwiping = false;
      }, { passive: true });

      holder.addEventListener('touchmove', function(e) {
        const diffX = Math.abs(e.changedTouches[0].screenX - touchStartX);
        const diffY = Math.abs(e.changedTouches[0].screenY - touchStartY);
        if (diffX > diffY && diffX > 10) {
          isSwiping = true;
          e.preventDefault();
        }
      }, { passive: false });

      holder.addEventListener('touchend', function(e) {
        if (!isSwiping) return;
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > swipeThreshold) {
          if (diff > 0) {
            goToSlide(currentIndex + 1);
          } else {
            goToSlide(currentIndex - 1);
          }
        }
      }, { passive: true });

      // Prevent link navigation when swiping
      holder.closest('a')?.addEventListener('click', function(e) {
        if (isSwiping) {
          e.preventDefault();
        }
      });
    }

    // Initialize on DOM ready with a slight delay to ensure theme JS has run
    setTimeout(initProductGridSlideshows, 200);

    // Re-initialize after Shopify section changes, AJAX loads, etc.
    document.addEventListener('shopify:section:load', function() {
      setTimeout(initProductGridSlideshows, 300);
    });

    // Watch for dynamically loaded content (Ajaxinate, etc.)
    const observer = new MutationObserver(function(mutations) {
      let shouldInit = false;
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.querySelector?.('.product__media__slider--always') || node.classList?.contains('product__media__slider--always'))) {
            shouldInit = true;
          }
        });
      });
      if (shouldInit) {
        setTimeout(initProductGridSlideshows, 100);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // ========================================
    // END PRODUCT GRID SLIDESHOW
    // ========================================

    // ========================================
    // FILTER COUNT BADGE
    // Syncs active filter count from [data-filter-count]
    // to the toggle button badge [data-toggle-filters-count]
    // ========================================
    function syncFilterCountBadge() {
      const countEl = document.querySelector('[data-filter-count]');
      const badge = document.querySelector('[data-toggle-filters-count]');
      if (!countEl || !badge) return;
      const count = parseInt(countEl.getAttribute('data-filter-count'), 10) || 0;
      badge.textContent = count > 0 ? count : '';
    }

    syncFilterCountBadge();

    // Re-sync after AJAX filter updates (theme re-renders [data-collection-filters] and [data-collection-products])
    const filterObserverTarget = document.querySelector('[data-collection-filters]')
      || document.querySelector('[data-collection-products]')?.parentNode;
    if (filterObserverTarget) {
      const filterObserver = new MutationObserver(function() {
        setTimeout(syncFilterCountBadge, 100);
      });
      filterObserver.observe(filterObserverTarget, { childList: true, subtree: true });
    }

    document.addEventListener('shopify:section:load', function() {
      setTimeout(syncFilterCountBadge, 300);
    });
    // ========================================
    // END FILTER COUNT BADGE
    // ========================================

    // DESKTOP: aggiungi la classe solo dove la voce è "BRAND"
    document.querySelectorAll(".menu__item.parent").forEach(function (parent) {
      const label = parent.querySelector(".navlink--toplevel .navtext");
      if (label && label.textContent.trim().toUpperCase().includes("BRAND")) {
        parent.classList.add("menu__item--brand");
      }
    });

    // MOBILE: aggiungi la classe solo ai LI livello 1 dove il testo è BRAND
    document
      .querySelectorAll("li.mobile-menu__item--level-1")
      .forEach(function (li) {
        // cerca il link principale di livello 1
        var link = li.querySelector(".mobile-navlink--level-1");
        if (link && link.textContent.trim().toUpperCase().includes("BRAND")) {
          li.classList.add("mobile-menu__item--brand");
        }
      });

    // Rimuovi il parametro lshst=collection dagli URL dei link dei prodotti
    function removeLshstParam(url) {
      if (!url) return url;
      try {
        const urlObj = new URL(url, window.location.origin);
        urlObj.searchParams.delete('lshst');
        return urlObj.pathname + urlObj.search + urlObj.hash;
      } catch (e) {
        // Se l'URL non è valido, rimuovi il parametro manualmente
        return url.replace(/[?&]lshst=[^&]*/g, '').replace(/[?&]$/, '');
      }
    }

    // Rimuovi il parametro dai link dei prodotti quando vengono cliccati
    document.addEventListener('click', function(e) {
      const link = e.target.closest('a[href*="/products/"]');
      if (link && link.hasAttribute('data-grid-link')) {
        const originalHref = link.getAttribute('href');
        if (originalHref && originalHref.includes('lshst=')) {
          const cleanHref = removeLshstParam(originalHref);
          link.setAttribute('href', cleanHref);
        }
      }
    }, true);

    // Rimuovi il parametro dall'URL corrente se presente
    if (window.location.search.includes('lshst=')) {
      const cleanUrl = removeLshstParam(window.location.href);
      if (cleanUrl !== window.location.pathname + window.location.search + window.location.hash) {
        window.history.replaceState({}, '', cleanUrl);
      }
    }
  });
})();

// ========================================
// BRAND FILTER PILLS
// ========================================
(function() {
  function initBrandFilterPills() {
    var pillsContainer = document.querySelector('[data-collection-filter-pills]');
    if (!pillsContainer) return;

    pillsContainer.addEventListener('click', function(e) {
      var pill = e.target.closest('[data-filter-pill]');
      if (!pill) return;

      var paramName = pill.getAttribute('data-filter-param-name');
      var value = pill.getAttribute('data-filter-value');
      var filtersForm = document.querySelector('[data-collection-filters-form]');
      if (!filtersForm) return;

      // Find the matching checkbox in the filter form
      var checkbox = filtersForm.querySelector(
        'input[type="checkbox"][name="' + CSS.escape(paramName) + '"][value="' + CSS.escape(value) + '"]'
      );

      if (checkbox) {
        window.__pillFilterActive = true;
        checkbox.checked = !checkbox.checked;
        pill.classList.toggle('filter-pill--active');
        filtersForm.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }

  // Sync pill active states from filter form checkboxes after AJAX updates
  function syncBrandFilterPills() {
    var pillsContainer = document.querySelector('[data-collection-filter-pills]');
    if (!pillsContainer) return;

    var pills = pillsContainer.querySelectorAll('[data-filter-pill]');
    var filtersForm = document.querySelector('[data-collection-filters-form]');
    if (!filtersForm) return;

    pills.forEach(function(pill) {
      var paramName = pill.getAttribute('data-filter-param-name');
      var value = pill.getAttribute('data-filter-value');
      var checkbox = filtersForm.querySelector(
        'input[type="checkbox"][name="' + CSS.escape(paramName) + '"][value="' + CSS.escape(value) + '"]'
      );

      if (checkbox) {
        if (checkbox.checked) {
          pill.classList.add('filter-pill--active');
        } else {
          pill.classList.remove('filter-pill--active');
        }
      }
    });
  }

  initBrandFilterPills();

  // Re-sync pills after AJAX filter updates via MutationObserver
  var filtersTarget = document.querySelector('[data-collection-filters]');
  if (filtersTarget) {
    var pillsObserver = new MutationObserver(function() {
      setTimeout(syncBrandFilterPills, 150);
    });
    pillsObserver.observe(filtersTarget, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', function() {
    initBrandFilterPills();
  });
})();
// ========================================
// END BRAND FILTER PILLS
// ========================================
